var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 4H3.6C2.716 4 2 4.703 2 5.571V15c0 .868.716 1.571 1.6 1.571h12.8c.884 0 1.6-.703 1.6-1.571V5.571C18 4.703 17.284 4 16.4 4zm-.32 3.338l-5.656 3.473a.811.811 0 01-.848 0L3.919 7.338a.664.664 0 01-.319-.564c0-.524.586-.843 1.038-.565L10 9.5l5.362-3.291c.452-.278 1.038.041 1.038.565 0 .229-.12.443-.32.564z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAlt);
export default __webpack_public_path__ + "static/media/email-alt.c20fdb40a35d6fd52f0078837d0da8e2.svg";
export { ForwardRef as ReactComponent };